import React from 'react'
import { PostMetricWithSoundbites } from '../../types'
import { StyledContainer } from './index.css'
import LinkItem from './LinkItem'

type TableProps = {
  data: PostMetricWithSoundbites[]
  widgetId: number
  onRowClick?: (targetRow: PostMetricWithSoundbites) => void
}

const Table = ({ data, widgetId, onRowClick }: TableProps) => (
  <StyledContainer>
    {data?.map((postMetric, idx) => (
      <LinkItem
        onRowClick={onRowClick}
        // eslint-disable-next-line react/no-array-index-key
        key={`${postMetric.postId}-${idx}`}
        postMetric={postMetric}
        widgetId={widgetId}
        index={idx}
      />
    ))}
  </StyledContainer>
)

export default Table
